<template>
  <spinner-container :loading="localLoading">
    <v-container class="dots-activity">
      <section v-if="data.dots_app_status == 1">
        <report-form @submit="submit" v-if="data.dots_enddate == null" />
        <v-card class="card--shadow" v-else>
          <v-card-title>
            <h3>
              Your DOT Activity has been stopped on {{ data.dots_enddate }}
            </h3>
          </v-card-title>
        </v-card>
      </section>
      <visit-report-list :datas="datas" />
    </v-container>
    <end-confirm
      confirmText="Are you sure want to stop?"
      :dialog="dialog"
      @confirmed="confirmed"
      @cancel="dialog = false"
    />
  </spinner-container>
</template>
<script>
import VisitReportList from "./NoApp/VisitReportList.vue";
import ReportForm from "./NoApp/ReportForm.vue";
import { mapState } from "vuex";
import SpinnerContainer from "../container/SpinnerContainer.vue";
import EndConfirm from "./modal/EndConfirm.vue";

export default {
  components: {
    VisitReportList,
    ReportForm,
    SpinnerContainer,
    EndConfirm,
  },
  data: () => ({
    dialog: false,
    currentData: "",
  }),
  methods: {
    submit(data) {
      if (this.checkError(data)) {
        if (data.status == 1) {
          this.currentData = data;
          this.dialog = true;
        } else {
          this.confirmed(data);
        }
      }
    },
    confirmed(data) {
      if (!data) data = this.currentData;
      data.dots_patient_id = this.$route.params.id;
      this.$store.dispatch("VisitReport/save", data).then((isPass) => {
        if (isPass) {
          this.dialog = false;
          this.$store.dispatch("VisitReport/getAll", {
            dots_patient_id: this.$route.params.id,
          });
          this.$store.dispatch("DotsPatient/getEach", {
            column: "id",
            value: this.$route.params.id,
          });
        }
      });
    },
    checkError(payload) {
      let insertedMonth = payload.month;
      let insertedYear = payload.year;

      var nowData = `${insertedYear}/${insertedMonth}/28`;

      if (new Date(nowData) < new Date(this.data.dots_startdate)) {
        this.$toast.error(
          "Your selected month and year should be greater than DOTS Startdate"
        );
        return false;
      } else if (payload.status == 1 && !payload.date) {
        this.$toast.error("Date is required");
        return false;
      } else if (payload.status == 1) {
        var endDate = new Date(payload.date);
        if (
          endDate.getMonth() + 1 != insertedMonth ||
          endDate.getFullYear() != insertedYear
        ) {
          this.$toast.error("Date should be in selected month and year");
          return false;
        }
      } else if (
        parseInt(payload.absent) +
          parseInt(payload.phone) +
          parseInt(payload.in_person) >
        31
      ) {
        this.$toast.error("Days should not e greater than 31");
        return false;
      }
      return true;
    },
  },
  created() {
    this.$store.dispatch("Loading/changeLocalLoading");

    this.$store
      .dispatch("DotsPatient/getEach", {
        column: "id",
        value: this.$route.params.id,
      })
      .then(() => {
        this.$store.dispatch("Loading/changeLocalLoading");
      });

    this.$store.dispatch("VisitReport/getAll", {
      dots_patient_id: this.$route.params.id,
    });
  },
  computed: {
    ...mapState("VisitReport", ["datas"]),
    ...mapState("DotsPatient", ["data"]),
    ...mapState("Loading", ["localLoading"]),
  },
};
</script>

<style scoped>
.dots-activity h3 {
  font-size: 20px;
  letter-spacing: 1px;
  font-weight: 400;
  color: #ff1744;
}
</style>
